
<script>
import VisaForm from './views/Form.vue'
import addIcon from '@/assets/images/icons/plus.svg?inline'
import removeIcon from '@/assets/images/icons/cancel.svg?inline'
import arrowIcon from '@/assets/images/icons/arrow-down.svg?inline'

export default {
  name: 'cart-visas',
  components: {
    VisaForm,
    addIcon,
    removeIcon,
    arrowIcon
  },
  data: () => ({
    active: false
  }),
  computed: {
    visas() {
      return this.$store.getters['cart/getVisas']
    },
    mainServiceIsTours() {
      return this.$store.getters['cart/getMainService'] === 'tours'
    }
  },
  methods: {
    addVisa() {
      this.active = true
      this.$store.commit('cart/setVisaInitial')
    },
    removedForm() {
      this.active = false
      this.$store.commit('cart/clearVisaeState')
    },
    toggleTourVisas() {
      this.active = !this.active
    }
  }
}
</script>

<template>
  <div class="cart__services--item">
    <div
      v-if="!active && !mainServiceIsTours"
      class="cart__item-header cart__item-header--empty"
    >
      <h3>Виза</h3>
      <div class="cart__item-header--row-btn">
        <div
          class="cart__item-header--btn"
          @click="addVisa"
        >
          <addIcon
            fill="#ffffff"
          />
          <span>добавить</span>
        </div>
      </div>
    </div>
    <div
      v-if="active && !mainServiceIsTours"
      class="cart__item-header"
    >
      <h3>Виза</h3>
      <div class="cart__item-header--row-btn">
        <div
          class="cart__item-header--btn"
          @click="removedForm"
        >
          <removeIcon
            fill="#ffffff"
          />
          <span>удалить</span>
        </div>
      </div>
    </div>
    <div
      v-if="mainServiceIsTours"
      class="cart__item-header"
      :class="{ 'cart__item-header--empty-tour': !active }"
    >
      <h3>Визы</h3>
      <div class="cart__item-header--row-btn">
        <div
          class="cart__item-header--btn"
          @click="toggleTourVisas"
        >
          <arrowIcon
            fill="#ffffff"
            class="cart__item-header--arrow-icon"
            :class="{ 'cart__item-header--arrow-icon-rotate': active }"
          />
        </div>
      </div>
    </div>
    <div
      v-if="active"
    >
      <div
        v-for="(visa, visaIndex) in visas"
        :key="visaIndex"
        class="cart__main"
      >
        <div class="cart__item-content">
          <div
            v-if="visa.visas.hasError"
          >
            <h2
              v-for="(error, index) in visa.visas.errors"
              :key="index"
              class="cart__error"
            >
              {{ error }}
            </h2>
          </div>
          <visa-form
            v-if="!visa.visas.hasError"
            :visa-index="visaIndex"
          />
        </div>
      </div>
    </div>
  </div>
</template>
